import FieldValidator from './_FieldValidator';

export default class ReCaptchaFieldValidator extends FieldValidator {
    el;

    constructor(el) {
        super('Please solve the recaptcha.');

        this.el = el;
    }

    async validate(value) {
        const widgetEl = this.el.querySelector('[data-grecaptcha-id]');
        if (typeof (widgetEl) === 'undefined') {
            return Promise.resolve({ valid: false, messages: [{ text: this.message }] });
        }

        const widgetId = widgetEl.dataset.grecaptchaId;
        const isValid = window.grecaptcha
            && window.grecaptcha.getResponse
            && window.grecaptcha.getResponse(widgetId).length > 0;

        if (isValid === false) {
            return Promise.resolve({ valid: false, messages: [{ text: this.message }] });
        }

        return Promise.resolve({ valid: true });
    }
}